export const SIZES = {
    MEDIUM: 'medium',
    SMALL: 'small',
};
export const DATA_BADGE = 'data-badgeSelect-badge';
export const DATA_DROPDOWN = 'data-badgeSelect-dropdownLayout';
//# sourceMappingURL=DataAttr.js.map